webpackJsonp([276417679053550],{

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n'], ['\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  top: 0;\n  z-index: 1;\n  width: 100vw;\n  height: 15vw;\n  background: linear-gradient(\n    rgba(0, 0, 0, 0.7),\n    rgba(0, 0, 0, 0.3),\n    rgba(0, 0, 0, 0)\n  );\n\n  @media (max-width: 767px) {\n    top: 0;\n    height: 30vh;\n    background: linear-gradient(\n      rgba(0, 0, 0, 0.4),\n      rgba(0, 0, 0, 0.3),\n      rgba(0, 0, 0, 0)\n    );\n  }\n'], ['\n  position: fixed;\n  top: 0;\n  z-index: 1;\n  width: 100vw;\n  height: 15vw;\n  background: linear-gradient(\n    rgba(0, 0, 0, 0.7),\n    rgba(0, 0, 0, 0.3),\n    rgba(0, 0, 0, 0)\n  );\n\n  @media (max-width: 767px) {\n    top: 0;\n    height: 30vh;\n    background: linear-gradient(\n      rgba(0, 0, 0, 0.4),\n      rgba(0, 0, 0, 0.3),\n      rgba(0, 0, 0, 0)\n    );\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  left: 0;\n  top: 60vh;\n  width: 100vw;\n  height: 20vh;\n  background: linear-gradient(\n    rgba(0, 0, 0, 0),\n    rgba(0, 0, 0, 0.2),\n    rgba(0, 0, 0, 0.4)\n  );\n  z-index: 1;\n  @media (max-width: 767px) {\n    height: 19vh;\n    top: 21vh;\n    background: linear-gradient(\n      rgba(0, 0, 0, 0),\n      rgba(0, 0, 0, 0.2),\n      rgba(0, 0, 0, 0.4)\n    );\n    // background-color: red;\n  }\n'], ['\n  position: absolute;\n  left: 0;\n  top: 60vh;\n  width: 100vw;\n  height: 20vh;\n  background: linear-gradient(\n    rgba(0, 0, 0, 0),\n    rgba(0, 0, 0, 0.2),\n    rgba(0, 0, 0, 0.4)\n  );\n  z-index: 1;\n  @media (max-width: 767px) {\n    height: 19vh;\n    top: 21vh;\n    background: linear-gradient(\n      rgba(0, 0, 0, 0),\n      rgba(0, 0, 0, 0.2),\n      rgba(0, 0, 0, 0.4)\n    );\n    // background-color: red;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: 100vw;\n  height: 80vh;\n  background-position: no-repeat center center;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  @media (max-width: 767px) {\n    height: 40vh;\n  }\n'], ['\n  width: 100vw;\n  height: 80vh;\n  background-position: no-repeat center center;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  @media (max-width: 767px) {\n    height: 40vh;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  height: 100vh;\n  background-color: white;\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  height: 100vh;\n  background-color: white;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding: 5vw;\n  color: gray;\n  background-color: white;\n  -webkit-columns: 2 200px;\n  -moz-columns: 2 200px;\n  columns: 2 200px;\n  -webkit-column-gap: 4em;\n  -moz-column-gap: 4em;\n  column-gap: 4em;\n\n  > h2 {\n    font-size: 1.5vw;\n    font-family: OpensansSemiboldItalic;\n    font-style: italic;\n    line-height: 1.6;\n  }\n\n  > em {\n    display: block;\n    font-family: OpensansRegular;\n    font-style: normal;\n    margin-top: 2.5vw;\n    // margin-bottom: 290px;\n    text-transform: uppercase;\n    font-size: 1vw;\n  }\n\n  > p {\n    column-break-before: always;\n    font-family: OpensansRegular;\n    font-size: 1vw;\n    line-height: 2;\n    margin-top: 0.3vw;\n  }\n\n}\n'], ['\n  padding: 5vw;\n  color: gray;\n  background-color: white;\n  -webkit-columns: 2 200px;\n  -moz-columns: 2 200px;\n  columns: 2 200px;\n  -webkit-column-gap: 4em;\n  -moz-column-gap: 4em;\n  column-gap: 4em;\n\n  > h2 {\n    font-size: 1.5vw;\n    font-family: OpensansSemiboldItalic;\n    font-style: italic;\n    line-height: 1.6;\n  }\n\n  > em {\n    display: block;\n    font-family: OpensansRegular;\n    font-style: normal;\n    margin-top: 2.5vw;\n    // margin-bottom: 290px;\n    text-transform: uppercase;\n    font-size: 1vw;\n  }\n\n  > p {\n    column-break-before: always;\n    font-family: OpensansRegular;\n    font-size: 1vw;\n    line-height: 2;\n    margin-top: 0.3vw;\n  }\n\n}\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  padding: 7vw;\n  color: gray;\n  background-color: white;\n\n  > h2 {\n    font-size: 3.5vw;\n    font-family: OpensansSemiboldItalic;\n    font-style: italic;\n    line-height: 1.6;\n  }\n\n  > em {\n    display: block;\n    font-family: OpensansRegular;\n    font-style: normal;\n    margin-top: -2vw;\n    text-transform: uppercase;\n    font-size: 2vw;\n  }\n\n  > p {\n    column-break-before: always;\n    font-family: OpensansRegular;\n    font-size: 3vw;\n    line-height: 2;\n    margin-top: 7vw;\n  }\n\n}\n'], ['\n  padding: 7vw;\n  color: gray;\n  background-color: white;\n\n  > h2 {\n    font-size: 3.5vw;\n    font-family: OpensansSemiboldItalic;\n    font-style: italic;\n    line-height: 1.6;\n  }\n\n  > em {\n    display: block;\n    font-family: OpensansRegular;\n    font-style: normal;\n    margin-top: -2vw;\n    text-transform: uppercase;\n    font-size: 2vw;\n  }\n\n  > p {\n    column-break-before: always;\n    font-family: OpensansRegular;\n    font-size: 3vw;\n    line-height: 2;\n    margin-top: 7vw;\n  }\n\n}\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 70vh;\n  left: 7.5vw;\n  font-family: OpensansItalic;\n  font-size: 2vw;\n  color: white;\n  z-index: 1;\n  @media (max-width: 767px) {\n    top: 32vh;\n    height: 19vh;\n    left: 7.5vw;\n    font-size: 5vw;\n  }\n'], ['\n  position: absolute;\n  top: 70vh;\n  left: 7.5vw;\n  font-family: OpensansItalic;\n  font-size: 2vw;\n  color: white;\n  z-index: 1;\n  @media (max-width: 767px) {\n    top: 32vh;\n    height: 19vh;\n    left: 7.5vw;\n    font-size: 5vw;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  width: 100vw;\n  height: 80vh;\n  @media (max-width: 767px) {\n    height: 40vh;\n  }\n'], ['\n  width: 100vw;\n  height: 80vh;\n  @media (max-width: 767px) {\n    height: 40vh;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(37);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _api = __webpack_require__(25);
	
	var _reactSlick = __webpack_require__(79);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _slide = __webpack_require__(82);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	var _reactResponsive = __webpack_require__(24);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Mobile = function Mobile(props) {
	  return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { maxWidth: 767 }));
	};
	var Desktop = function Desktop(props) {
	  return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { minWidth: 992 }));
	};
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var NavigationDimmer = _styledComponents2.default.div(_templateObject2);
	var HeroDimmer = _styledComponents2.default.div(_templateObject3);
	var Image = _styledComponents2.default.div(_templateObject4);
	var ContentWrapper = _styledComponents2.default.div(_templateObject5);
	var ContentBlock = _styledComponents2.default.div(_templateObject6);
	var ContentBlockMobile = _styledComponents2.default.div(_templateObject7);
	var Title = _styledComponents2.default.div(_templateObject8);
	
	var settings = {
	  dots: false,
	  arrows: false,
	  fade: true,
	  infinite: true,
	  speed: 500,
	  autoplay: true,
	  lazyLoad: false,
	  swipe: false,
	  slidesToShow: 1,
	  slidesToScroll: 1
	};
	
	var SlideShow = (0, _styledComponents2.default)(_reactSlick2.default)(_templateObject9);
	
	var Memory = function (_Component) {
	  _inherits(Memory, _Component);
	
	  function Memory() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Memory);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      page: { slides_1: [], slides_2: [] },
	      isLoading: true,
	      lang: ''
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Memory.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.setState({ isLoading: true });
	    var lang = window.location.search;
	    (0, _api.getPageContents)('/memoria', lang).then(function (page) {
	      _this2.setState({ page: page, isLoading: false, lang: lang });
	    });
	  };
	
	  Memory.prototype.render = function render() {
	    var _state$page = this.state.page,
	        slides_1 = _state$page.slides_1,
	        slides_2 = _state$page.slides_2,
	        bio_text_1 = _state$page.bio_text_1,
	        bio_text_2 = _state$page.bio_text_2;
	
	    return _react2.default.createElement(
	      _gatsbyPluginPageTransitions2.default,
	      null,
	      _react2.default.createElement(NavigationDimmer, null),
	      _react2.default.createElement(
	        Wrapper,
	        null,
	        !this.state.isLoading && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(HeroDimmer, null),
	          _react2.default.createElement(
	            Title,
	            null,
	            this.state.lang === '?lang=en' ? 'Memory' : 'Mem\xF3ria'
	          ),
	          _react2.default.createElement(
	            SlideShow,
	            settings,
	            slides_1.map(function (slide, index) {
	              return _react2.default.createElement(
	                'div',
	                { key: index },
	                _react2.default.createElement(Image, {
	                  style: {
	                    backgroundImage: 'url(' + slide + ')'
	                  }
	                })
	              );
	            })
	          ),
	          _react2.default.createElement(
	            ContentWrapper,
	            null,
	            _react2.default.createElement(
	              Desktop,
	              null,
	              _react2.default.createElement(ContentBlock, {
	                dangerouslySetInnerHTML: { __html: bio_text_1 }
	              })
	            ),
	            _react2.default.createElement(
	              Mobile,
	              null,
	              _react2.default.createElement(ContentBlockMobile, {
	                dangerouslySetInnerHTML: { __html: bio_text_1 }
	              })
	            ),
	            _react2.default.createElement(
	              SlideShow,
	              settings,
	              slides_2.map(function (slide, index) {
	                return _react2.default.createElement(
	                  'div',
	                  { key: index },
	                  _react2.default.createElement(Image, {
	                    style: {
	                      backgroundImage: 'url(' + slide + ')'
	                    }
	                  })
	                );
	              })
	            ),
	            _react2.default.createElement(
	              Desktop,
	              null,
	              _react2.default.createElement(ContentBlock, {
	                dangerouslySetInnerHTML: { __html: bio_text_2 }
	              })
	            ),
	            _react2.default.createElement(
	              Mobile,
	              null,
	              _react2.default.createElement(ContentBlockMobile, {
	                dangerouslySetInnerHTML: { __html: bio_text_2 }
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Memory;
	}(_react.Component);
	
	exports.default = Memory;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-memoria-js-7b6e371be2bb1b959788.js